// extracted by mini-css-extract-plugin
export var filterIncDec = "_dn-0";
export var leftBorder = "_dn-1";
export var rightBorder = "_dn-2";
export var stringInput = "_dn-3";